import type { Class } from "@/types";
import { CHARACTER_CLASSES } from "@/constants";

export const cleric: Class = {
  name: "Cleric",
  id: CHARACTER_CLASSES.CLERIC,
  classType: CHARACTER_CLASSES.CLERIC,
  description:
    "Clerics are those who have devoted themselves to the service of a deity, pantheon or other belief system. Most Clerics spend their time in mundane forms of service such as preaching and ministering in a temple; but there are those who are called to go abroad from the temple and serve their deity in a more direct way, smiting undead monsters and aiding in the battle against evil and chaos. Player character Clerics are assumed to be among the latter group.",
  hitDie: "1d6",
  primaryAttribute: "wisdom",
  abilityRequirements: [
    {
      ability: "wisdom",
      min: 9,
    },
  ],
  allowedWeapons: [
    "warhammer",
    "mace",
    "maul",
    "club",
    "quarterstaff",
    "sling",
  ],
  allowedArmor: [],
  spellcasting: {
    spellsPerLevel: {
      1: [],
      2: [1],
      3: [2],
      4: [2, 1],
      5: [2, 2],
      6: [2, 2, 1],
      7: [3, 2, 2],
      8: [3, 2, 2, 1],
      9: [3, 3, 2, 2],
      10: [3, 3, 2, 2, 1],
      11: [4, 3, 3, 2, 2],
      12: [4, 4, 3, 2, 2, 1],
      13: [4, 4, 3, 3, 2, 2],
      14: [4, 4, 4, 3, 2, 2],
      15: [4, 4, 4, 3, 3, 2],
      16: [5, 4, 4, 3, 3, 2],
      17: [5, 5, 4, 3, 3, 2],
      18: [5, 5, 4, 4, 3, 3],
      19: [6, 5, 4, 4, 3, 3],
      20: [6, 5, 5, 4, 3, 3],
    },
  },
  specialAbilities: [
    {
      name: "Turn Undead",
      description:
        "Clerics have the power to Turn the Undead, that is, to drive away undead monsters by means of faith alone.",
    },
  ],
  experienceTable: {
    1: 0,
    2: 1500,
    3: 3000,
    4: 6000,
    5: 12000,
    6: 24000,
    7: 48000,
    8: 90000,
    9: 180000,
    10: 270000,
    11: 360000,
    12: 450000,
    13: 540000,
    14: 630000,
    15: 720000,
    16: 810000,
    17: 900000,
    18: 990000,
    19: 1080000,
    20: 1170000,
  },
  supplementalContent: false,
};
